<template>
  <div class="video-palyer">
    <video
      id="videoPlayer"
      class="video-js vjs-default-skin vjs-big-play-centered"
      playsinline
      webkit-playsinline
      muted
      loop
      preload="auto"
      autoplay="autoplay"
      controlsList="nodownload"
      oncontextmenu="return false">
      您的浏览器不支持 HTML5 video 标签。
    </video>
  </div>
</template>

<script setup>
import { ref, onUnmounted, onMounted } from 'vue';
import videoJs from 'video.js';
import 'video.js/dist/video-js.css';
import { computed } from 'vue';
import { useStore } from 'vuex';

defineOptions({
  name: 'VideoPlayer',
});
defineExpose({
  playVideo,
});

const store = useStore();
const info = computed(() => store.state.appInfo);

const videoPlayer = ref();

function playVideo() {
  videoPlayer.value = videoJs('videoPlayer');
  videoPlayer.value.src([
    {
      type: 'video/mp4',
      src: info.value.video,
    },
  ]);
  videoPlayer.value.play();
}

const destroyVideo = () => {
  if (videoPlayer.value) {
    videoPlayer.value.dispose();
  }
};

onMounted(() => {
  setTimeout(() => {
    playVideo();
  }, 1000);
});
onUnmounted(() => {
  destroyVideo();
});
</script>

<style lang="scss" scoped>
.video-palyer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 200px;
  overflow: hidden;
  z-index: 98;
}
.video-js {
  width: 100%;
  height: 100%;
}
.vjs-tech {
  object-fit: cover;
  width: 100%;
}
</style>
